export default __webpack_public_path__ + "static/tide-and-tone-open-graph-6c653cd73a0bded69d8240babbd23b80.jpg";